(function () {
  'use strict';

  var STORAGE_KEY = 'mrjewels:wishlist:v1';
  var memoryItems = [];
  var storageAvailable = true;

  function normalize(items) {
    if (!Array.isArray(items)) return [];

    var seen = {};
    return items.filter(function (item) {
      if (!item || typeof item.handle !== 'string') return false;
      var handle = item.handle.trim();
      if (!handle || seen[handle]) return false;
      seen[handle] = true;
      item.handle = handle;
      item.addedAt = Number(item.addedAt) || Date.now();
      return true;
    });
  }

  function read() {
    if (!storageAvailable) return memoryItems.slice();

    try {
      var value = window.localStorage.getItem(STORAGE_KEY);
      if (!value) return [];
      try {
        return normalize(JSON.parse(value));
      } catch (parseError) {
        window.localStorage.removeItem(STORAGE_KEY);
        return [];
      }
    } catch (error) {
      storageAvailable = false;
      return memoryItems.slice();
    }
  }

  function write(items) {
    var nextItems = normalize(items);
    memoryItems = nextItems.slice();

    if (storageAvailable) {
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(nextItems));
      } catch (error) {
        storageAvailable = false;
      }
    }

    document.dispatchEvent(
      new CustomEvent('mrjewels:wishlist:change', {
        detail: { items: nextItems.slice() }
      })
    );
    return nextItems;
  }

  function contains(handle, items) {
    return items.some(function (item) {
      return item.handle === handle;
    });
  }

  function setToggleState(toggle, isSaved) {
    var handle = toggle.getAttribute('data-product-handle') || '';
    var productName = toggle.getAttribute('data-product-title') || 'this product';
    var label = isSaved ? 'Remove from wishlist' : 'Add to wishlist';

    toggle.classList.toggle('is-active', isSaved);
    toggle.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
    toggle.setAttribute('aria-label', label + ': ' + productName);

    var labelElement = toggle.querySelector('[data-wishlist-label]');
    if (labelElement) labelElement.textContent = label;
    if (!handle) toggle.disabled = true;
  }

  function refresh(items) {
    var currentItems = normalize(items || read());
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (toggle) {
      setToggleState(toggle, contains(toggle.getAttribute('data-product-handle'), currentItems));
    });

    document.querySelectorAll('[data-wishlist-count]').forEach(function (count) {
      count.textContent = String(currentItems.length);
      var itemLabel =
        currentItems.length + (currentItems.length === 1 ? ' item in wishlist' : ' items in wishlist');
      count.setAttribute('aria-label', itemLabel);
      var wishlistLink = count.closest('.header-wishlist-link');
      if (wishlistLink) wishlistLink.setAttribute('aria-label', 'Open wishlist, ' + itemLabel);
    });
  }

  function toggle(handle) {
    if (!handle) return;
    var items = read();
    if (contains(handle, items)) {
      write(
        items.filter(function (item) {
          return item.handle !== handle;
        })
      );
    } else {
      items.unshift({ handle: handle, addedAt: Date.now() });
      write(items);
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-wishlist-toggle]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    toggle(button.getAttribute('data-product-handle'));
  });

  document.addEventListener('mrjewels:wishlist:change', function (event) {
    refresh(event.detail && event.detail.items);
  });

  window.addEventListener('storage', function (event) {
    if (event.key === STORAGE_KEY) {
      storageAvailable = true;
      refresh();
      document.dispatchEvent(
        new CustomEvent('mrjewels:wishlist:external-change', {
          detail: { items: read() }
        })
      );
    }
  });

  document.addEventListener('shopify:section:load', function () {
    refresh();
  });

  function observeDynamicControls() {
    if (!window.MutationObserver || !document.body) return;
    var refreshQueued = false;
    var observer = new MutationObserver(function (mutations) {
      var hasWishlistControl = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          return (
            node.nodeType === 1 &&
            (node.matches('[data-wishlist-toggle]') || node.querySelector('[data-wishlist-toggle]'))
          );
        });
      });

      if (hasWishlistControl && !refreshQueued) {
        refreshQueued = true;
        window.requestAnimationFrame(function () {
          refreshQueued = false;
          refresh();
        });
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  window.MRJewelsWishlist = {
    key: STORAGE_KEY,
    read: read,
    write: write,
    remove: function (handle) {
      write(
        read().filter(function (item) {
          return item.handle !== handle;
        })
      );
    },
    refresh: refresh
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      memoryItems = read();
      refresh(memoryItems);
      observeDynamicControls();
    });
  } else {
    memoryItems = read();
    refresh(memoryItems);
    observeDynamicControls();
  }
})();
